export const MAX_EXERCISE_TO_DO_NOTIFICATION = 99;
export const MAX_EXERCISE_IN_LEARNING_BOOKMARKS = 50;
export const MAX_BOOKMARKS_TO_STUDY_PER_ARTICLE = 10;
export const MAX_WORDS_IN_BOOKMARK_FOR_EXERCISES = 3;
export const MINUTES_TO_RE_ENABLE_AUDIO_AFTER_DISABLE = 15;
export const MAX_COOLDOWN_INTERVAL = 11520;
export const HINT = "H";
export const CORRECT = "C";
export const WRONG = "W";
export const TRANSLATE_WORD = "T";
export const SOLUTION = "S";
